type ID = string;

export interface CountResult {
    totalItems: number;
}

export interface ListRequest {
    page: number,
    pageSize: number,
}

export interface PaginationResult<T> {
    items: Array<T>;
    totalItems: number;
    /** 0-based index */
    page: number;
    pageSize: number;
    numPages: number;
}

export interface GenericResponse {
    status: string;
    message: string;
}

export interface EnumSelect {
    id: string;
    name: string;
}

export enum OrderDirection {
    Asc = "asc",
    Desc = "desc",
}

export interface OrderBy {
    name: string;
    direction: OrderDirection;
}
